var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"body-container pa-0 elevation-3",staticStyle:{"max-width":"1600px"},attrs:{"fluid":""}},[_c('ListSearchToolbar',{attrs:{"model":"workOrders"}}),_c('WorkOrdersList',{ref:"workOrdersList"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }